export default function AppContainer ({ children }) {
  return (
    <div className="main">
      <div className="container">
        { children }
      </div>
    </div>
  )
}